import { LitElement, html } from 'lit';
import { icon } from '@Root/lib/lit-3form-block/icons';
import { styles } from './css';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { classMap } from 'lit/directives/class-map.js';
import {
  fireAdobeAnalyticsEvent,
  analyticsCtaDataObject,
  analyticsLabelFromString,
  handleAdobeNavEvent,
} from '../../../../helpers/adobe-analytics';

import '@Root/lib/lit-3form-block/components/cta-text';

import {
  SHARED_CLASSES,
  SHARED_ELEMENTS,
} from '@Root/lib/lit-3form-block/styles.js';

import { LIT_CSS_VARIABLES, GRID_LAYOUT } from '@Root/lib/lit-styles.js';
export class WalterBarrel extends LitElement {
  static get properties() {
    return {
      content: { type: Object },
      expanded: { type: Boolean },
    };
  }

  static get styles() {
    return [
      LIT_CSS_VARIABLES,
      SHARED_ELEMENTS,
      SHARED_CLASSES,
      GRID_LAYOUT,
      styles,
    ];
  }

  constructor() {
    super();

    this.content = JSON.parse(this.getAttribute('content'));
  }

  get alignLogo() {
    return this.content.align_logo_in_title == '1';
  }

  get downloads() {
    return this.content.downloads;
  }

  get rows() {
    return this.content.rows;
  }

  get text() {
    return this.content.text;
  }

  get title() {
    const title = this.content.title || '';
    return title.toUpperCase();
  }

  render() {
    return html`
      <div
        class=${classMap({
          'barrel-wrapper-expanded': this.expanded,
          'barrel-wrapper-closed': !this.expanded,
          'print-none': this.hideInPrint,
        })}
      >
        <div class="barrel-header" @click="${this.toggleVisbility}">
          <span class="barrel-heavy-text">
            <span>${this.title}</span>
            ${this.alignLogo
              ? html`
                  <span class="align-icon">
                    <img src="/static/icons/SVG/align-leaf-18x10.svg" />
                  </span>
                `
              : html``}
          </span>
          <span class="barrel-header-icon print-none">
            ${icon(this.barrelHeaderIcon)}
          </span>
        </div>
        ${this.text
          ? html`
              <div class="barrel-text">${this.text}</div>
            `
          : html``}
        ${this.rows && this.rows.length > 0
          ? this.rows.map(row => {
              if (!row.content && row.value) row.content = row.value;
              if (!row.content && row.text) row.content = row.text;
              return html`
                <div class="material-row-wrapper">
                  <span class="material-row-header">
                    <p class="barrel-heavy-text">${unsafeHTML(row.header)}</p>
                  </span>
                  <span class="material-row-value">
                    ${this.renderRowContent(row.text || row.content)}
                  </span>
                </div>
              `;
            })
          : html``}
        ${this.downloads && this.downloads.length > 0
          ? this.downloads.map(download => {
              return html`
                <div class="downloads-wrapper print-none">
                  <cta-text
                    cta-data=${JSON.stringify(download)}
                    .ctaAnalyticsData=${analyticsCtaDataObject(
                      download,
                      'Walter Product Details'
                    )}
                    hide-right-arrow-svg="true"
                    target-blank="true"
                    left-download-svg="true"
                  ></cta-text>
                </div>
              `;
            })
          : html``}
      </div>
    `;
  }

  get barrelHeaderIcon() {
    return this.expanded ? 'minus' : 'plus';
  }

  get hideInPrint() {
    return this.content.hide_in_print;
  }

  toggleVisbility() {
    this.expanded = !this.expanded;
    if (this.expanded) {
      const eventData = {
        type: 'click',
        detail: {
          eVar8: `INP|Barrel Expanded|${this.title}`,
        },
      };
      fireAdobeAnalyticsEvent(eventData);
    }
  }

  renderRowContent(rowContent) {
    if (typeof rowContent !== 'object') return this.rowContentText(rowContent);

    if (Array.isArray(rowContent))
      return html`
        ${rowContent.map(this.rowContentLink.bind(this))}
      `;

    return html`
      ${this.rowContentLink(rowContent)}
    `;
  }

  rowContentLink(link) {
    return typeof link === 'object'
      ? html`
          <a
            href=${link.url}
            @click="${event => this.handleRowLinkClick(link, event)}"
          >
            ${this.rowContentText(link.text)}
          </a>
        `
      : html``;
  }

  handleRowLinkClick(link, event) {
    if (!link || !link.url) return;
    handleAdobeNavEvent({
      navString: `NAV|${analyticsLabelFromString(
        this.content.title || 'Walter Barrel'
      )}|${analyticsLabelFromString(link.text || link.url)}`,
      destinationUrl: link.url,
      event,
    });
  }

  rowContentText(text) {
    text = text || '';
    // remove any empty <p> tags coming from the CMS editor
    text = text.replaceAll('<p><br /></p>', '');
    return html`
      <p class="row-content-text">
        ${unsafeHTML(text)}
      </p>
    `;
  }
}
customElements.define('walter-barrel', WalterBarrel);
